import { Injectable } from "@angular/core";
import { CityApiService } from "./services/api.service";


@Injectable({
  providedIn: "root"
})
export class CoreService {

  constructor(
    private apiService: CityApiService
  ) {
  }
}
